import { render, staticRenderFns } from "./SelectPhoneNumber.vue?vue&type=template&id=96f74574"
import script from "./SelectPhoneNumber.vue?vue&type=script&lang=js"
export * from "./SelectPhoneNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports